import { useAppActions } from 'reducers/slices/loanOfficer/realEstateAgentsSlice';
import { pathOr } from 'ramda';
import { useFetchStatus } from 'utils/fetchStatusUtils';
import { useSelector } from 'react-redux';

export default () => {
  const {
    loadRealEstateAgents,
    loadMoreRealEstateAgents,
    addToWaitlist,
    loadWaitlistRealEstateAgents,
    loadMoreWaitlistRealEstateAgents,
    loadInFavoritesRealEstateAgents,
    loadMoreInFavoritesRealEstateAgents,
  } = useAppActions();
  const {
    realEstateAgents,
    meta,
    realEstateAgentsLoadingStatus,

    addingToWaitlistStatus,

    waitlistRealEstateAgents,
    waitlistRealEstateAgentsLoadingStatus,
    waitlistRealEstateAgentsMeta,

    inFavoritesRealEstateAgents,
    inFavoritesRealEstateAgentsLoadingStatus,
    inFavoritesRealEstateAgentsMeta,
  } = useSelector(state => state.loanOfficerRealEstateAgentsSlice);

  const totalCount = pathOr(null, ['totalCount'], meta);
  const waitlistTotalCount = pathOr(null, ['totalCount'], waitlistRealEstateAgentsMeta);
  const inFavoritesTotalCount = pathOr(null, ['totalCount'], inFavoritesRealEstateAgentsMeta);

  return {
    isRealEstateAgentsLoading: useFetchStatus(realEstateAgentsLoadingStatus).isPending,
    isRealEstateAgentsIdle: useFetchStatus(realEstateAgentsLoadingStatus).isIdle,
    loadRealEstateAgents,
    realEstateAgents,
    totalCount,
    meta,
    loadMoreRealEstateAgents,

    addToWaitlist,
    isAddingToWaitlist: useFetchStatus(addingToWaitlistStatus).isPending,

    loadWaitlistRealEstateAgents,
    loadMoreWaitlistRealEstateAgents,
    waitlistRealEstateAgents,
    waitlistRealEstateAgentsMeta,
    isWaitlistRealEstateAgentsLoading: useFetchStatus(waitlistRealEstateAgentsLoadingStatus).isPending,
    isWaitlistRealEstateAgentsIdle: useFetchStatus(waitlistRealEstateAgentsLoadingStatus).isIdle,
    waitlistTotalCount,

    loadInFavoritesRealEstateAgents,
    loadMoreInFavoritesRealEstateAgents,
    inFavoritesRealEstateAgents,
    inFavoritesRealEstateAgentsMeta,
    isInFavoritesRealEstateAgentsLoading: useFetchStatus(inFavoritesRealEstateAgentsLoadingStatus).isPending,
    isInFavoritesRealEstateAgentsIdle: useFetchStatus(inFavoritesRealEstateAgentsLoadingStatus).isPending,
    inFavoritesTotalCount,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/loanOfficer/useRealEstateAgents.js